import {CLEAR_SEARCH, SET_DATE, SET_SEARCH, SET_TRAVELER} from "../actions/search";

const initialState ={
    "OriginDestinationInformation": [
        {
            "OriginLocation": {
                "Code": null,
                "Name": null,
                "Terminal": null,
                "CityName": null
            },
            "DestinationLocation": {
                "code": null,
                "Name": null,
                "Terminal": null,
                "CityName": null
            },
            "DepartureDate": null
        }
    ],
    "TravelerInfoSummary": {
        "AirTravelerAvail": [
            {
                "Quantity": 1,
                "PassengerType": 1
            },
            {
                "Quantity": 0,
                "PassengerType": 2
            },
            {
                "Quantity": 0,
                "PassengerType": 3
            }
        ]
    },
    "Travelpreferences": {
        "CabinPref": [
            "All"
        ]
    },
    "FlightType": null,
    "PrimaryLangId": "en"
};

export default function search(state = initialState , action = {}){
    switch (action.type) {
        case SET_SEARCH :
            const { search } = action;
            return search;
        case SET_DATE :
            const { date } = action;
            return {
                ...state,
                "OriginDestinationInformation":{
                    ...state.OriginDestinationInformation,
                    "DepartureDate":date
                }
            };
        case SET_TRAVELER :
            const { traveler } = action;
            return {
                ...state,
                "TravelerInfoSummary": {
                    "AirTravelerAvail":traveler
                }
            };
        case CLEAR_SEARCH :
            return initialState;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/redux/reducers/searchReducer.js